'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dateFormatMixin = undefined;

var _format = require('date-fns/format');

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateFormatMixin = exports.dateFormatMixin = {

    methods: {

        /**
         * Formats a given date.
         * @param date
         * @param format
         */
        $date: function $date(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY';

            if (!(date instanceof Date)) {
                date = new Date(date);
            }
            return (0, _format2.default)(date, format);
        }
    }

};